import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Tracks Meta Pixel PageView on each client-side route change (SPA navigation).
 * The initial PageView is sent from index.html on first load.
 */
function MetaPixelTracker() {
  const { pathname } = useLocation();

  useEffect(() => {
    if (typeof window === 'undefined' || !window.fbq) return;
    window.fbq('track', 'PageView');
  }, [pathname]);

  return null;
}

export default MetaPixelTracker;
